import { Alert, Linking, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { ScreenContainer } from "@/shared/components/ui/screen-container";
import { Link, Stack } from "expo-router";
import { supabase } from "@lezz/supabase";
import { useState } from "react";
import { useDeleteAccount } from "@/features/profile/api/profile";
import { SignOutButton } from "@/features/auth/components/sign-out-button";
import { EXTERNAL_LINKS } from "@/shared/constants/links";
import { BackButton } from "@/shared/components/ui/back-button";
import { BottomSheet } from "@/shared/components/ui/bottom-sheet";
import { Button } from "@/shared/components/ui/button";
import { Heading } from "@/shared/components/ui/heading";
import { ListRow } from "@/shared/components/ui/list-row";
import { useAuthContext } from "@/features/auth/hooks/use-auth-context";

export default function SettingsScreen() {
  const insets = useSafeAreaInsets();
  const { mutate: deleteAccount } = useDeleteAccount();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const { session } = useAuthContext();

  const handleDeleteConfirm = () => {
    setDeleteModalVisible(false);
    deleteAccount(undefined, {
      onSuccess: () => supabase.auth.signOut(),
      onError: (error) => Alert.alert("Erro", error.message),
    });
  };

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <ScreenContainer style={{ paddingTop: 0 }}>
        {/* Header */}
        <View
          className="border-border flex-row items-center justify-between border-b px-4 pb-4"
          style={{ paddingTop: insets.top || 24 }}
        >
          <BackButton />
          <Heading variant="section">Configurações</Heading>
          <View className="h-10 w-10" />
        </View>

        {/* Content */}
        <View className="flex-1 px-6">
          <Link href={"/user/edit"} asChild>
            <ListRow
              leadingIcon="pencil-outline"
              label="Editar perfil"
              accessibilityLabel="Editar perfil"
            />
          </Link>
          <Link href={"/user/invites"} asChild>
            <ListRow
              leadingIcon="person-add-outline"
              label="Convidar amigas"
              accessibilityLabel="Convidar amigas"
            />
          </Link>
          <ListRow
            leadingIcon="help-circle-outline"
            label="Suporte"
            onPress={() =>
              Linking.openURL(
                `${EXTERNAL_LINKS.support}?email=${session?.user.email}`
              )
            }
            accessibilityLabel="Suporte"
            accessibilityRole="link"
          />
          <ListRow
            leadingIcon="document-text-outline"
            label="Termos de Uso"
            onPress={() => Linking.openURL(EXTERNAL_LINKS.termsOfUse)}
            accessibilityLabel="Termos de Uso"
            accessibilityRole="link"
          />
          <ListRow
            leadingIcon="shield-checkmark-outline"
            label="Política de Privacidade"
            onPress={() => Linking.openURL(EXTERNAL_LINKS.privacyPolicy)}
            accessibilityLabel="Política de Privacidade"
            accessibilityRole="link"
          />
          <ListRow
            leadingIcon="trash-outline"
            tone="pink"
            label="Deletar conta"
            onPress={() => setDeleteModalVisible(true)}
            accessibilityLabel="Deletar conta"
          />
          <SignOutButton />
        </View>
      </ScreenContainer>

      <BottomSheet
        visible={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
      >
        <Heading variant="section" className="mb-8 px-5 pt-4">
          Deletar conta?
        </Heading>
        <View className="border-border flex-row gap-3 border-t px-5 pt-4 pb-2">
          <Button
            variant="outline"
            className="flex-1"
            onPress={() => setDeleteModalVisible(false)}
            accessibilityLabel="Cancelar"
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            className="flex-1"
            onPress={handleDeleteConfirm}
            accessibilityLabel="Confirmar exclusão"
          >
            Deletar
          </Button>
        </View>
      </BottomSheet>
    </>
  );
}
